import { RouterProvider } from 'react-router';
import { ToastContainer } from 'react-toastify';
import { router } from './routes/routeConstant';
import 'react-toastify/dist/ReactToastify.css';
import 'react-quill/dist/quill.snow.css';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  return (
    <div className="text-text">
      <LanguageProvider>
        <ToastContainer autoClose={2000} />
        <RouterProvider router={router} />
      </LanguageProvider>
    </div>
  );
}

export default App;
